@if (!checking) {
  <div class="container">
    <div class="position-absolute background-logo">
      <svg-icon src="/assets/img/icons/logo.svg" />
    </div>
    <div class="row w-100">
      <div class="col-12 header">
        <app-auth-header />
        <app-language-switch />
      </div>
    </div>
    <div class="row w-100 login-row">
      <div class="col-12 col-md-6 offset-md-3 d-flex align-items-center justify-content-center">
        <app-login-form formHeader="{{ 'login.text' | translate }}" />
      </div>
    </div>
</div>
}
